export enum FancardOffersNav {
  FANCARD_OFFERS = 'wobau_fancard'
}
